module.exports = __webpack_public_path__ + "static/img/qunzhu_1.87d9bc10.jpg";